import { put, call, takeLatest } from "redux-saga/effects";

import {
  getAllEvents$,
  getEventBookings$,
  getEventAttendees$,
  getAllwebinars$
} from "../actions/event";

// import { getEventWithId$ } from "../actions/eventById"

import {
  getAllEvents,
  getEventBookingDetails,
  getEventAttendeesDetails,
  getAllwebinars
} from "../../services/requestors/event";

function* handleGetAllEvents(action) {
  try {
    yield put(getAllEvents$.request());
    const { data } = yield call(getAllEvents, action.payload);
    yield put(getAllEvents$.success(data));
  } catch (error) {
    yield put(getAllEvents$.failure(error));
  } finally {
    yield put(getAllEvents$.fulfill());
  }
}

function* handleGetAllwebinars(action) {
  try {
    yield put(getAllwebinars$.request());
    const { data } = yield call(getAllwebinars, action.payload);
    yield put(getAllwebinars$.success(data));
  } catch (error) {
    yield put(getAllwebinars$.failure(error));
  } finally {
    yield put(getAllwebinars$.fulfill());
  }
}

function* handleGetEventBookings(action) {
  try {
    yield put(getEventBookings$.request());
    const { data } = yield call(getEventBookingDetails, action.payload);
    yield put(getEventBookings$.success(data.data.bookingList));
  } catch (error) {
    yield put(getEventBookings$.failure(error));
  } finally {
    yield put(getEventBookings$.fulfill());
  }
}

function* handleGetEventAttendees(action) {
  try {
    yield put(getEventAttendees$.request());
    const { data } = yield call(getEventAttendeesDetails, action.payload);
    yield put(getEventAttendees$.success(data.data));
  } catch (error) {
    yield put(getEventAttendees$.failure(error));
  } finally {
    yield put(getEventAttendees$.fulfill());
  }
}

export default function* eventWatcher() {

  yield takeLatest(getAllwebinars$.TRIGGER, handleGetAllwebinars);
  yield takeLatest(getAllEvents$.TRIGGER, handleGetAllEvents);
  yield takeLatest(getEventBookings$.TRIGGER, handleGetEventBookings);
  yield takeLatest(getEventAttendees$.TRIGGER, handleGetEventAttendees);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/event.js